import { queryBuilder } from '~/api';

export const postLogout = async (): Promise<void> => {
  const { data } = await queryBuilder('POST', 'auth/logout', undefined);
  return data;
};
